export default __webpack_public_path__ + "static/media/dot.ca549527.svg";